import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_2e097122";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_2e097122" };
/** script content **/
require("./segment-picker.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex2e097122%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fsegment-picker%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_2e097122"],
    ctorType: "component",
    outputPath: "components/index2e097122/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-date-picker-popup': getComponent(require("../date-picker-popup/index.mpx?isComponent&outputPath=components%2Findex012972d9%2Findex")), 'cube-time-picker-popup': getComponent(require("../time-picker-popup/index.mpx?isComponent&outputPath=components%2Findex07b2fcda%2Findex")), 'cube-cascade-picker-popup': getComponent(require("../cascade-picker-popup/index.mpx?isComponent&outputPath=components%2Findex2c8c38ed%2Findex")), 'cube-picker-popup': getComponent(require("../picker-popup/index.mpx?isComponent&outputPath=components%2Findex57353298%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
